<script>
import Layout from "../_layouts/main"
import PageHeader from "@/components/page-header"
import List from "../../components/board/list"

export default {
  components: {
    Layout,
    PageHeader,
    List
  },
  data() {
    return {
      title: this.$t('게임사 업데이트'),
    }
  },
  mounted() {
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <List :boardKey="'vendor_update'" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
